import React, { useEffect } from 'react';
import { ComparisonModule } from '../components/ComparisonModule';
import { LOGO_URL } from '../data/mock';
import { trackPageView, trackViewContent } from '../utils/fbPixel';

const ComparePage = () => {
  // Track PageView when landing on /compare
  useEffect(() => {
    trackPageView();
    trackViewContent('Compare Page', 'Landing');
  }, []);

  const handleShowOptions = (data) => {
    console.log('Options shown:', data);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Compact Header */}
      <header className="bg-white border-b border-gray-100 py-2 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <a href="/" className="inline-block">
            <img
              src={LOGO_URL}
              alt="CompareYourOptions.com.au"
              className="h-6 w-auto object-contain"
            />
          </a>
        </div>
      </header>

      {/* Compare Tool */}
      <main className="flex-1 py-3 md:py-4">
        <ComparisonModule onShowOptions={handleShowOptions} />
      </main>

      {/* Simple Footer */}
      <footer className="bg-white border-t border-gray-100 py-4 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center gap-4">
              <img
                src={LOGO_URL}
                alt="CompareYourOptions.com.au"
                className="h-5 w-auto object-contain opacity-60"
              />
              <span className="text-xs text-gray-400">
                © {new Date().getFullYear()} CompareYourOptions.com.au
              </span>
            </div>
            <div className="flex items-center gap-4 text-xs text-gray-400">
              <a href="/" className="hover:text-cyo-orange transition-colors">Home</a>
              <a href="/#how-it-works" className="hover:text-cyo-orange transition-colors">How It Works</a>
              <a href="/#about" className="hover:text-cyo-orange transition-colors">About</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ComparePage;
